import React, { useEffect, useRef, useState } from 'react';
import CheckboxRenderer from '../../../components/CheckboxRenderer';

const CheckBoxHeader = (params) => {
  const [checked, setChecked] = useState(false);
  const [isIntermediate, setIsIntermediate] = useState(false);
  const ibtrailers = useRef([])

  const onChange = (event, checked) => {
    params.api.selectAll(checked, ibtrailers.current);
  };

  const setSelectionState = () => {
    let checked = false;
    let isIntermediate = false;
    let isNotChecked = false;
    ibtrailers.current = []

    // Calculate the state of the header checkbox by iterating through all filtered data
    // ibtrailers.current will hold the IDs of trailers that need to be updated with their checked/unchecked status
    // isIntermediate will be true if any trailer is in an intermediate state or if at least one trailer is checked and another is unchecked
    // checked will be true if all trailers are selected
    // isNotChecked will be true if all trailers are unselected

    params.api.forEachNodeAfterFilter((node) => {
      ibtrailers.current.push(node.data.id);
    
      if (node.data.isIntermediate) {
        isIntermediate = true;
      } else if (node.data.isSelected) {
        checked = true;
      } else if(!node.data.isSelected){
        isNotChecked = true;
      }
    });
    
    if(checked && isNotChecked){
      checked= false;
      isNotChecked = false;
      isIntermediate = true;
    }
    setChecked(checked);
    setIsIntermediate(isIntermediate);
  };

  useEffect(() => {
    setSelectionState();
    params.api.addEventListener('rowDataUpdated', setSelectionState);
    params.api.addEventListener('filterChanged', setSelectionState);
    return () => {
      params.api.removeEventListener('rowDataUpdated', setSelectionState);
      params.api.removeEventListener('filterChanged', setSelectionState);
    };
  }, [params.api]);

  return (
    <CheckboxRenderer
      value={{ checked: checked, isIntermediate: isIntermediate, disabled: false }}
      onChange={onChange}
    />
  );
};

export default CheckBoxHeader;
